<template>
    <div v-if="current">
        <v-row>
            <v-col cols="12" sm="2">
                <v-btn color="primary" @click="normalizeRegister()">Normal. CPF/CNPJ</v-btn>
            </v-col>
            <v-col cols="12" sm="2">
                <v-btn color="primary" @click="normalizeTelephone()">Normal. Telefones</v-btn>
            </v-col>
            <v-col cols="12" sm="2">
                <v-btn color="primary" @click="normalizeCellphone()">Normal. Celulares</v-btn>
            </v-col>
            <v-col cols="12" sm="2">
                <v-btn color="primary" @click="normalizeZipcode()">Normal. CEP</v-btn>
            </v-col>
            <v-col cols="12" sm="4">
                <v-btn color="success" @click="dialogCheckAll()">Checagem geral</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="4">
                <v-alert dense text type="error">
                {{ counter_open }} clientes para serem integrados
                </v-alert>
            </v-col>
            <v-col cols="12" sm="4">
                <v-alert dense text type="success">
                {{ counter_done }} clientes totais já integrados
                </v-alert>
            </v-col>
            <v-col cols="12" sm="4">
                <v-alert dense text type="success">
                {{ counter_done_unique }} clientes únicos já integrados
                </v-alert>
            </v-col>
        </v-row>
        <v-simple-table>
            <thead>
                <tr>
                <th>Nome</th>
                <th>Pendências</th>
                <th>Notificações</th>
                <th>Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in current" :key="item.id">
                <td>{{ item.name }}</td>
                <td>
                  <v-chip v-if="!item.compelsId">NG</v-chip>
                  <v-chip v-if="!item.compelsCode">CD</v-chip>
                  <v-chip v-if="!item.compelsZipcode">CP</v-chip>
                  <v-chip v-if="!item.compelsCity">MN</v-chip>
                  <v-chip v-if="!item.compelsAddress">ED</v-chip>
                </td>
                <td>
                    <span v-for="notification in item.notifications" :key="notification.index" style="margin: 2px">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip :color="colorNotification(notification.level)" v-bind="attrs" v-on="on">{{ notification.message }}</v-chip>
                            </template>
                            <span>{{ notification.data }}</span>
                        </v-tooltip>
                    </span>
                </td>
                <td><v-btn icon @click="compels(item.id)" title="Executar integração"><v-icon>mdi-cog</v-icon></v-btn></td>
                </tr>
            </tbody>
        </v-simple-table>
        
        <v-dialog v-model="dialog_compels" max-width="600">
            <v-card>
                <v-card-title>
                    Integração Compels - {{client.name}}
                </v-card-title>
                <v-card-text>
                    <v-row dense>
                      <v-col>
                        <v-alert dense text type="error" v-if="client.notifications">
                            Cliente ainda tem notificações não resolvidas!
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <span v-for="notification in client.notifications" :key="notification.index" style="margin: 2px">
                          <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                  <v-chip :color="colorNotification(notification.level)" v-bind="attrs" v-on="on">{{ notification.message }}</v-chip>
                              </template>
                              <span>{{ notification.data }}</span>
                          </v-tooltip>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>Negociante</v-col>
                      <v-col><v-alert text dense :type="compelsColor(client.compelsId)">{{ client.compelsId | compelsStatus }}</v-alert></v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>Código</v-col>
                      <v-col><v-alert text dense :type="compelsColor(client.compelsCode)">{{ client.compelsCode | compelsStatus }}</v-alert></v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>CEP</v-col>
                      <v-col><v-alert text dense :type="compelsColor(client.compelsZipcode)">{{ client.compelsZipcode | compelsStatus }}</v-alert></v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>Cidade</v-col>
                      <v-col><v-alert text dense :type="compelsColor(client.compelsCity)">{{ client.compelsCity | compelsStatus }}</v-alert></v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>Endereço</v-col>
                      <v-col><v-alert text dense :type="compelsColor(client.compelsAddress)">{{ client.compelsAddress | compelsStatus }}</v-alert></v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success" v-if="!client.notifications" @click="compelsIntegration(client.id)">Executar Integração</v-btn>
                    <v-btn @click="dialog_compels = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_check" width="600">
          <v-card>
            <v-card-title>Checagem geral da integração de Clientes</v-card-title>
            <v-card-text>
              <p>
              Executar checagem geral da integração Compels?
              </p>
              <v-alert type="warning">Essa tarefa poderá demorar 30 minutos para ser finalizada!</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-btn color="success" @click="postCheckAll()">Executar</v-btn>
              <v-btn color="default" @click="dialog_check = false"
                >Cancelar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Por favor aguarde
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import api from '../../api/index.js';
export default {
  data: () => ({
    current: [],
    client: {},
    counter_open: 0,
    counter_done: 0,
    counter_done_unique: 0,
    dialog_loading: false,
    dialog_compels: false,
    dialog_check: false
  }),
  created: function() {
    this.compelsOpen();
    this.compelsDoneCount();
    this.compelsDoneUniqueCount();
  },
  methods: {
    compels: function(id){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/client/compels/open/"+id, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.client = response.data;
        me.dialog_compels = true;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar cliente para integração!");
      });  
    },
    compelsIntegration: function(id){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.post("/client/compels/integration/"+id, null, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.client = response.data;
        me.compelsOpen();
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao realizar integração!");
      });
    },
    compelsOpen: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/client/compels/open", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.current = response.data;
        me.counter_open = response.data.length;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar listagem!");
      });
    },
    compelsDoneCount: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/client/compels/done/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.counter_done = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    compelsDoneUniqueCount: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/client/compels/done/unique/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.counter_done_unique = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar contagem!");
      });
    },
    normalizeRegister: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.put("/client/normalize/register", null, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        alert(response.data + " documentos normalizados!");
        me.compelsOpen();
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao normalizar documentos!");
      });
    },
    normalizeTelephone: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.put("/client/normalize/telephone", null, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        alert(response.data + " telefones normalizados!");
        me.compelsOpen();
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao normalizar telefones!");
      });
    },
    normalizeCellphone: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.put("/client/normalize/cellphone", null, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        alert(response.data + " celulares normalizados!");
        me.compelsOpen();
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao normalizar celulares!");
      });
    },
    normalizeZipcode: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.put("/client/normalize/zipcode", null, {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        alert(response.data + " CEPs normalizados!");
        me.compelsOpen();
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao normalizar CEPs!");
      });
    },
    dialogCheckAll: function(){
      this.dialog_check = true;
    },
    postCheckAll: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_check = false;
      me.dialog_loading = true;
      api.post("/client/compels/check", null, {headers: { Authorization: "Bearer " + token }})
      .then(function() {
        me.dialog_loading = false;
        alert("Comando enviado com sucesso!");
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao solicitar checagem!");
      });
    },
    colorNotification: function(level){
        var ret = "default"
        if(level==1){
            ret = "info";
        }else if(level==2){
            ret = "warning"
        }else if(level==3){
            ret = "error"
        }
        return ret;
    },
    compelsColor: function(status){
      var ret = "error";
      if(status){
        ret = "success";
      }
      return ret;
    }
  },
  filters: {
    compelsStatus: function(status){
      var ret = "Pendente";
      if(status){
        ret = "Integrado";
      }
      return ret;
    }
  }
}
</script>